import type { CanvasLayoutChangeFromTool, ParseCanvasLayoutChangesParams } from '../types';
import coerceToRecord from './coerceToRecord';
import getStringValue from './getStringValue';

// Tool args may arrive as a parsed object or a JSON string; normalize into the
// layout-change shape the items-cache patch expects.
const parseCanvasLayoutChanges = ({
    value,
}: ParseCanvasLayoutChangesParams): CanvasLayoutChangeFromTool[] => {
    if (!Array.isArray(value)) {
        return [];
    }

    const changes: CanvasLayoutChangeFromTool[] = [];

    for (const rawChange of value) {
        const changeRecord = coerceToRecord({ value: rawChange });
        const itemId = getStringValue({ value: changeRecord.itemId });
        if (itemId.length === 0) {
            continue;
        }

        const positionRecord = coerceToRecord({ value: changeRecord.position });
        const positionX =
            typeof positionRecord.x === 'number' && Number.isFinite(positionRecord.x)
                ? positionRecord.x
                : null;
        const positionY =
            typeof positionRecord.y === 'number' && Number.isFinite(positionRecord.y)
                ? positionRecord.y
                : null;
        const hasPosition = positionX !== null && positionY !== null;

        const sizeRecord = coerceToRecord({ value: changeRecord.size });
        const width =
            typeof sizeRecord.width === 'number' && Number.isFinite(sizeRecord.width)
                ? sizeRecord.width
                : null;
        const height =
            typeof sizeRecord.height === 'number' && Number.isFinite(sizeRecord.height)
                ? sizeRecord.height
                : null;
        const hasSize = width !== null && height !== null && width > 0 && height > 0;

        if (!hasPosition && !hasSize) {
            continue;
        }

        changes.push({
            itemId,
            ...(hasPosition ? { position: { x: positionX, y: positionY } } : {}),
            ...(hasSize ? { size: { width, height } } : {}),
        });
    }

    return changes;
};

export default parseCanvasLayoutChanges;
